import { opacify, transparentize } from 'polished';
export const setAlpha = (color, alpha) => opacify(alpha, transparentize(1, color));
//# sourceMappingURL=setAlpha.js.map